import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import styles from './styles.jsx';
import {
  Hidden
} from '@material-ui/core';
import { withRouter } from "react-router";
import ReactGA from 'react-ga';
import {contentData} from './content.jsx';

import ProductsDesktop from './ProductsDesktop/ProductsDesktop.jsx';
import ProductsMobile from './ProductsMobile/ProductsMobile.jsx';

class Products extends Component{

  componentDidMount(){
    window.scrollTo(0,0)
    ReactGA.initialize('UA-138339728-1');
    ReactGA.pageview(window.location.pathname);
  }

  sendToPage = (event, url) => {
    this.props.history.push(url);
  } 

  render(){

    const {language} = this.props
    const content = contentData[language]

    let desktopView = (
      <Hidden smDown>
        <ProductsDesktop content={content} sendToPage={this.sendToPage}/>
      </Hidden>
    )

    let mobileView = (
      <Hidden mdUp>
        <ProductsMobile content={content} sendToPage={this.sendToPage}/>
      </Hidden>
    )
    
    return(
      <div>
      {desktopView}
      {mobileView}
    </div>
    )
  }
}

export default withRouter(withStyles(styles)(Products));
